import React from 'react';

const Commandes = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Gestion des Commandes</h1>
      <div className="bg-white rounded-lg shadow p-4">
        <p>Page de gestion des commandes en cours de développement.</p>
      </div>
    </div>
  );
};

export default Commandes; 